// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --hover-border: 2px solid var(--primary-hover-color);
}

.DropOrChooseFilePicker-module_file_picker_container_ME6z6 {
  width: 100%;
  max-width: 600px;
  min-width: 400px;
}

.DropOrChooseFilePicker-module_drop_zone_bfJMc {
  width: 100%;
  display: grid;
  place-content: center;
  border: 2px dashed lightgray;
  border-radius: 10px;
  padding: 18px;
  gap: 4px;
  text-align: center;
}

.DropOrChooseFilePicker-module_drop_zone_bfJMc.DropOrChooseFilePicker-module_dragover_gCDj3 {
  border: var(--hover-border);
  opacity: 0.6;
}

.DropOrChooseFilePicker-module_fp_label_omftF:hover {
  border: var(--hover-border);
}

.DropOrChooseFilePicker-module_fp_label_omftF {
  cursor: pointer;
  border: 2px solid lightgray;
  border-radius: 5px;
  padding: 8px;
}

.DropOrChooseFilePicker-module_selected_files_preview_JvWSk {
  width: 100%;
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.DropOrChooseFilePicker-module_selected_files_label_kO90i {
  font-weight: 600;
  font-size: larger;
  margin-bottom: 4px;
  color: var(--primary-bos-color);
}

.DropOrChooseFilePicker-module_selected_file_Zv5BX {
  display: flex;
  gap: 4px;
  align-items: center;
  color: var(--muted-text);
  background-color: var(--bp-light-gray2);
  padding: 15px;
  border-radius: 5px;
}

.DropOrChooseFilePicker-module_selected_file_Zv5BX img {
  width: 50px;
  margin-right: 20px;
}

.DropOrChooseFilePicker-module_selected_file_info_jFALk {
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
  gap: 4px;
  min-width: 50px;
}

.DropOrChooseFilePicker-module_selected_file_info_jFALk p {
  margin-bottom: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 50px;
}

.DropOrChooseFilePicker-module_selected_file_name_qjsAk {
  font-weight: 600;
  flex-shrink: 1;
}

.DropOrChooseFilePicker-module_selected_file_ext_YaZPH {
  font-weight: 600;
  flex-shrink: 0;
}

.DropOrChooseFilePicker-module_selected_file_size_NxnTP {
  font-weight: 500;
  font-style: italic;
  flex-shrink: 0;
  margin-left: auto;
  text-align: end;
}

.DropOrChooseFilePicker-module_selected_file_del_U7ipS {
  opacity: 0 !important;
  transition: opacity 0.3s ease;
}

.DropOrChooseFilePicker-module_selected_file_Zv5BX:hover .DropOrChooseFilePicker-module_selected_file_del_U7ipS {
  opacity: 1 !important;
}

.DropOrChooseFilePicker-module_selected_file_del_U7ipS:hover {
  opacity: 1 !important;
  background-color: transparent !important;
  color: var(--uu-red-rocks) !important;
}
`, "",{"version":3,"sources":["webpack://./src/client/components/Generic/Documents/DropOrChooseFilePicker.module.css"],"names":[],"mappings":"AAAA;EACE,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,4BAA4B;EAC5B,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,wBAAwB;EACxB,uCAAuC;EACvC,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,wCAAwC;EACxC,qCAAqC;AACvC","sourcesContent":[":root {\n  --hover-border: 2px solid var(--primary-hover-color);\n}\n\n.file_picker_container {\n  width: 100%;\n  max-width: 600px;\n  min-width: 400px;\n}\n\n.drop_zone {\n  width: 100%;\n  display: grid;\n  place-content: center;\n  border: 2px dashed lightgray;\n  border-radius: 10px;\n  padding: 18px;\n  gap: 4px;\n  text-align: center;\n}\n\n.drop_zone.dragover {\n  border: var(--hover-border);\n  opacity: 0.6;\n}\n\n.fp_label:hover {\n  border: var(--hover-border);\n}\n\n.fp_label {\n  cursor: pointer;\n  border: 2px solid lightgray;\n  border-radius: 5px;\n  padding: 8px;\n}\n\n.selected_files_preview {\n  width: 100%;\n  margin-top: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.selected_files_label {\n  font-weight: 600;\n  font-size: larger;\n  margin-bottom: 4px;\n  color: var(--primary-bos-color);\n}\n\n.selected_file {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  color: var(--muted-text);\n  background-color: var(--bp-light-gray2);\n  padding: 15px;\n  border-radius: 5px;\n}\n\n.selected_file img {\n  width: 50px;\n  margin-right: 20px;\n}\n\n.selected_file_info {\n  display: flex;\n  flex-grow: 1;\n  justify-content: space-between;\n  gap: 4px;\n  min-width: 50px;\n}\n\n.selected_file_info p {\n  margin-bottom: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 50px;\n}\n\n.selected_file_name {\n  font-weight: 600;\n  flex-shrink: 1;\n}\n\n.selected_file_ext {\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.selected_file_size {\n  font-weight: 500;\n  font-style: italic;\n  flex-shrink: 0;\n  margin-left: auto;\n  text-align: end;\n}\n\n.selected_file_del {\n  opacity: 0 !important;\n  transition: opacity 0.3s ease;\n}\n\n.selected_file:hover .selected_file_del {\n  opacity: 1 !important;\n}\n\n.selected_file_del:hover {\n  opacity: 1 !important;\n  background-color: transparent !important;\n  color: var(--uu-red-rocks) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"file_picker_container": `DropOrChooseFilePicker-module_file_picker_container_ME6z6`,
	"drop_zone": `DropOrChooseFilePicker-module_drop_zone_bfJMc`,
	"dragover": `DropOrChooseFilePicker-module_dragover_gCDj3`,
	"fp_label": `DropOrChooseFilePicker-module_fp_label_omftF`,
	"selected_files_preview": `DropOrChooseFilePicker-module_selected_files_preview_JvWSk`,
	"selected_files_label": `DropOrChooseFilePicker-module_selected_files_label_kO90i`,
	"selected_file": `DropOrChooseFilePicker-module_selected_file_Zv5BX`,
	"selected_file_info": `DropOrChooseFilePicker-module_selected_file_info_jFALk`,
	"selected_file_name": `DropOrChooseFilePicker-module_selected_file_name_qjsAk`,
	"selected_file_ext": `DropOrChooseFilePicker-module_selected_file_ext_YaZPH`,
	"selected_file_size": `DropOrChooseFilePicker-module_selected_file_size_NxnTP`,
	"selected_file_del": `DropOrChooseFilePicker-module_selected_file_del_U7ipS`
};
export default ___CSS_LOADER_EXPORT___;
